// Price ID and Plans configuration service
// Centralized location for Stripe price IDs and plan details

// ---- SWITCH BETWEEN TEST AND PRODUCTION PRICE IDs ----
// Comment/uncomment the appropriate section to switch between test and production

// TEST Price IDs
// export const PRICE_IDS = {
//   contributor: 'price_1RGnHCCTqq6nTI6oBOQeBGkJ', // Test $1.99/month
//   member: 'price_1RGnHkCTqq6nTI6oZP3ihbrQ',      // Test $3.99/month
//   screamerPlus: 'price_1RGnI5CTqq6nTI6oTHxRO4G5'  // Test $9.99/month
// };

// PRODUCTION Price IDs - uncomment to use production
export const PRICE_IDS = {
  member: 'price_1RKPeQCTqq6nTI6orWZQfGPN', // $2.99/month
};

// Plan details with features and pricing info
export const PLANS = [
  {
    id: 'member',
    name: 'Member',
    price: '$2.99',
    period: '/ month',
    priceId: PRICE_IDS.member,
    features: [
      'Movies + Podcasts',
      'Full community access',
      'Screamify Originals',
      'Film Festival Access'
    ],
    cta: 'Become a Member'
  }
]; 